module.exports = __webpack_public_path__ + "static/media/icon_picture.3939ce41.svg";